import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../components/Icon/Icon";
import { iconSizeMixin } from "./iconSizeMixin";
/** @mixin iconOffsetMixin */

/**
 * Vertically align an Icon component based on the font type and the icon size.
 *
 * @example
 * import { iconOffsetMixin, IconHeart } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${iconOffsetMixin}
 * `;
 *
 * <Component fontType="h1" iconSize="sm">I <IconHeart /> aligned icons</Component>
 *
 * @method
 * @param props {object}
 * @param props.fontType {string} The font type of the component
 *     (this determines the line-height and font-size).
 * @param props.iconSize {string} An explicit size for the icon, otherwise the font-size from
 *     `fontType` will be used.
 * @param props.theme {object}
 * @return {CSSObject}
 */

export var iconOffsetMixin = function iconOffsetMixin(props) {
  var fontType = props.fontType,
      iconSize = props.iconSize;
  return token({
    lineHeights: "lineHeights",
    fontSizes: "fontSizes",
    iconSizes: "icons.sizes"
  }, function (_ref) {
    var lineHeights = _ref.lineHeights,
        fontSizes = _ref.fontSizes,
        iconSizes = _ref.iconSizes;
    var lineHeight = lineHeights && lineHeights[fontType];
    var size;
    var sizeCSS;

    if (iconSize) {
      size = iconSizes && iconSizes[iconSize];
      sizeCSS = iconSizeMixin(Object.assign({}, props, {
        iconSize: size
      }));
    } else {
      size = fontSizes && fontSizes[fontType];
    }

    return css(["", " > ", "{position:relative;top:", "px;}"], sizeCSS, StyledIcon, (lineHeight - size) / 2);
  })(props);
};